import React, { useEffect } from "react";
import QlikCard from "shared/components/QlikCard";
import QlikObject from "shared/components/QlikObject";

export default function Organizers({ title, pageTitle, menuItemsStrings }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <QlikObject
              className="page-title"
              id="gxkqpBZ"
              height="35px"
              showLoader={false}
            /> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject id="ujXFmm" height="35px" showLoader={false} />
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-center">
          <div className="col-12">
            {/* vizTable */}
            <QlikCard
              id="3b35be04-d5d7-4626-9089-d88eb0a81630"
              height="670px"
              showLoader={true}
              showExport={true}
              showHeader={true}
              exportText = {menuItemsStrings.exportText}
              exportCompletedText = {menuItemsStrings.exportCompletedText}
              closeBtnText = {menuItemsStrings.closeBtnText}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
